import { render, staticRenderFns } from "./UkHousingActSectionTwentyOne.vue?vue&type=template&id=77f3ae5e&scoped=true&"
import script from "./UkHousingActSectionTwentyOne.vue?vue&type=script&lang=js&"
export * from "./UkHousingActSectionTwentyOne.vue?vue&type=script&lang=js&"
import style0 from "./UkHousingActSectionTwentyOne.vue?vue&type=style&index=0&id=77f3ae5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3ae5e",
  null
  
)

export default component.exports